
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("daZiC", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $997bc248fd2f580e$export$bdfd709ae4826697, (v) => $997bc248fd2f580e$export$bdfd709ae4826697 = v);
var $997bc248fd2f580e$export$bdfd709ae4826697;
var $997bc248fd2f580e$export$c9e73fbda7da57b6;
var $997bc248fd2f580e$export$5a759dc7a1cfb72a;
"use strict";
var $997bc248fd2f580e$var$bundleURL = {};
function $997bc248fd2f580e$var$getBundleURLCached(id) {
    var value = $997bc248fd2f580e$var$bundleURL[id];
    if (!value) {
        value = $997bc248fd2f580e$var$getBundleURL();
        $997bc248fd2f580e$var$bundleURL[id] = value;
    }
    return value;
}
function $997bc248fd2f580e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $997bc248fd2f580e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $997bc248fd2f580e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $997bc248fd2f580e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$997bc248fd2f580e$export$bdfd709ae4826697 = $997bc248fd2f580e$var$getBundleURLCached;
$997bc248fd2f580e$export$c9e73fbda7da57b6 = $997bc248fd2f580e$var$getBaseURL;
$997bc248fd2f580e$export$5a759dc7a1cfb72a = $997bc248fd2f580e$var$getOrigin;

});

var $6a343d7ac61f495c$exports = {};

$6a343d7ac61f495c$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "frame.HASH_REF_8bd8d8d2ae324e44.js";


var $ac0e1d7ee96b8aa6$exports = {};

$ac0e1d7ee96b8aa6$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "util.HASH_REF_4018b9e89ea9afe5.js";


parcelRequire("aVUB5");
var $ba2d132ae0da1365$exports = {};

$ba2d132ae0da1365$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "images.HASH_REF_f59632e8004fc85d.js";


var $0266371e64ab86ba$exports = {};

$0266371e64ab86ba$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "notes.HASH_REF_621adccc9b487d73.js";


var $65ef413d3dde8062$exports = {};

$65ef413d3dde8062$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "photos.HASH_REF_c921116c4bf4116c.js";


var $1ae4ee8f199ea8b9$exports = {};

$1ae4ee8f199ea8b9$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "axis.HASH_REF_3b54bec5d120bd2f.js";


var $4d3a9f47b5b69781$exports = {};

$4d3a9f47b5b69781$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "lithology.HASH_REF_8ddebd6638ad00eb.js";


var $d00353031a2a6b09$exports = {};

$d00353031a2a6b09$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "flooding-surface.HASH_REF_4a9402e408250fac.js";


var $a27fe8d71cb244fa$exports = {};

$a27fe8d71cb244fa$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "symbol-column.HASH_REF_aab55cdb46e26c82.js";


var $92c1e7dc3d3df44d$exports = {};

$92c1e7dc3d3df44d$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "edit-overlay.HASH_REF_dc7c3fd871890a5d.js";


var $14848557cad42200$exports = {};

$14848557cad42200$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "editor.HASH_REF_2b715cb800e09c6d.js";


var $7662cad411bbc1ea$exports = {};

$7662cad411bbc1ea$exports = (parcelRequire("daZiC")).getBundleURL('enxL4') + "grainsize.HASH_REF_16a454961d192952.js";




//# sourceMappingURL=index.js.map
